import { render, staticRenderFns } from "./HistoricoDetalhe.vue?vue&type=template&id=7c225ca2"
import script from "./HistoricoDetalhe.vue?vue&type=script&lang=js"
export * from "./HistoricoDetalhe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports